module.exports = __webpack_public_path__ + "media/calculator.1a101d84.mp4";